module.exports = __webpack_public_path__ + "static/media/2 6 Ordkjedetest-Feil-hus-grei.818150b6.mp3";